import React from 'react';
import { useTranslation } from 'react-i18next';
import './login.scss';

import { Constant } from '../../services/services';

interface UserNotConfirmEmailProps {
    onResendEmail: () => void;
    resendStatus: number;
}

const UserNotConfirmEmail = ({ onResendEmail, resendStatus }: UserNotConfirmEmailProps) => {
    const { t } = useTranslation();

    return (
        <div className="confirm-email-page">
            <p className="page-title">{t("confirm_email.account_not_activated")}</p>
            {resendStatus == Constant.resendStatuses.processing && <p className="success-text">{t("confirm_email.resend_email_confirm_process")}</p>}
            {resendStatus == Constant.resendStatuses.resendEmailSuccess && <p className="success-text">{t("confirm_email.resend_email_success")}</p>}
            {
                <span className="hyperlink" style={{ float: "right" }} onClick={onResendEmail}>
                    {resendStatus == Constant.resendStatuses.resendEmailSuccess ? t('confirm_email.to_login') : t('confirm_email.resend_email')}
                </span>
            }
        </div>
    );
};

export default UserNotConfirmEmail;